import { TranslationContext } from '@core/i18n/context';
import { useTranslation } from '@core/widgets/i18n';
/**
 *
 */
export const WidgetTranslationWrapper = ({ children, }) => (<TranslationContext.Provider value={useTranslation()}>
    {children}
  </TranslationContext.Provider>);
